import { Typography } from '@mui/material';
import { Spacer } from '@sparemin/blockhead';
import * as S from './styles';

export interface CampaignCreditsProps {
  remaining?: number;
}

const CampaignCredits: React.FC<CampaignCreditsProps> = ({ remaining }) => (
  <S.CampaignCredits>
    <Spacer
      orientation="horizontal"
      space="4px"
      align="center"
      justify="flex-start"
    >
      <S.CreditTitle variant="h4" fontWeight={700}>
        Credit
      </S.CreditTitle>

      <S.CreditDescription variant="h2" fontWeight={400}>
        Campaign credit remaining this month:
      </S.CreditDescription>
    </Spacer>

    <Typography variant="h2">${remaining}</Typography>
  </S.CampaignCredits>
);

export default CampaignCredits;
